import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateProductRecommendation } from '../../../../views/market-comparison/market-comparison.actions';
import RecommendedProductHeaderView from './recommended-product-header.presenter';

// Map & Connect
export const mapStateToProps = state => ({
  cidn: state.dataBootStrapReducer.authentication.cidn,
  authorableContent: state.authorableContentReducer.authorableContent.marketComparison,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateProductRecommendation }, dispatch),
});

const RecommendedProductHeader = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecommendedProductHeaderView);

export default RecommendedProductHeader;
